import React from 'react';
import { useParams } from 'react-router-dom';
import Cookies from './Cookies';
import Impresszum from './Impresszum';
import PrivacyPolicy from './PrivacyPolicy';
import MobilePrivacyPolicy from './MobilePrivacyPolicy';

const PolicyPage = ({ isMobile = false }) => {
    const { policy } = useParams();

    switch (policy) {
        case 'privacy-policy':
            return <PrivacyPolicy isMobile={isMobile} />;
        case 'mobile-privacy-policy':
            return <MobilePrivacyPolicy isMobile={isMobile} />;
        case 'sutibeallitasok':
            return <Cookies />;
        case 'impresszum':
            return <Impresszum />;
        default:
            return <div>Az oldal nem található</div>;
    }
};

export default PolicyPage;
